module.exports = __webpack_public_path__ + "img/WM casino.a34184e7.jpg";